<template>
    <div class="container">
        <md-dialog :md-active.sync="modCrearCentroCostos" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.codigo}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="codigo" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.descripcion}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="descripcion" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.centro_costo}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="centro_costo" class="form-control">
                    </b-col>
                </b-row>
                <md-dialog-actions class="mt-3">
                    <md-button class="md-primary" @click="guardarCentroCostos">{{ labels.save }}</md-button>
                    <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
import CentroCostos from '../../../services/CentroCostos'
export default {
    name : 'Crear',
    props: ['modCrearCentroCostos'],
    data: () => ({
        codigo : '',
        descripcion : '',
        centro_costo : '',
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Crear centro costos',
                    save : 'Guardar',
                    close : 'Cerrar',
                    codigo : 'Código',
                    descripcion : 'Descripción',
                    centro_costo : 'Centro de Costo',
                }
            }else{
                return {
                    title : 'Create cost center',
                    save : 'Save',
                    close : 'Close',
                    codigo : 'Code',
                    descripcion : 'Description',
                    centro_costo : 'Centro de Costo',
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        guardarCentroCostos(){
            const dataForm = [
                this.codigo,
                this.descripcion,
                this.centro_costo
            ]

            if(dataForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            }else{
                let info = {
                    'codigo' : this.codigo,
                    'descripcion' : this.descripcion,
                    'centro_costo' : this.centro_costo,
                    'idUser' : this.$store.state.userId
                }
                // console.log(info);
                CentroCostos.createCentroCostos(info)
                .then((res) => {
                    if(res.status == 201){
                        this.$toast.success(res.data.message)
                        location.reload()
                    }
                })
                .catch((err) => {
                    if(err.response.status == 409){
                        this.$toast.error(err.response.data.message)
                    }else{
                        this.$toast.error("Algo pasó, intentalo de nuevo")
                    }
                })
            }
        }
    },
}
</script>

<style>

</style>
